/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions } from '@tanstack/react-query';

import type {
  ApiResponse,
  BboStockManagementBadRequestResponse,
  BboStockManagementFailureResponseResponse,
  BboStockManagementForbiddenResponse,
  BboStockManagementUnauthorizedResponse,
  StockCountRequest,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Store stock count data and user activity history related to stock counting
 * @summary This endpoint is used to store the stock counting into dB and maintaing user activity history
 */
export const postStockCount = (status: string, stockCountRequest: StockCountRequest) => {
  return customInstance<ApiResponse>({
    url: `/bm-stock-management-service/v1/stock-count/status/${status}`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: stockCountRequest,
  });
};

export const getPostStockCountMutationOptions = <
  TError = ErrorType<
    | BboStockManagementBadRequestResponse
    | BboStockManagementUnauthorizedResponse
    | BboStockManagementForbiddenResponse
    | BboStockManagementFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postStockCount>>,
    TError,
    { status: string; data: StockCountRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postStockCount>>,
  TError,
  { status: string; data: StockCountRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postStockCount>>,
    { status: string; data: StockCountRequest }
  > = (props) => {
    const { status, data } = props ?? {};

    return postStockCount(status, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostStockCountMutationResult = NonNullable<Awaited<ReturnType<typeof postStockCount>>>;
export type PostStockCountMutationBody = StockCountRequest;
export type PostStockCountMutationError = ErrorType<
  | BboStockManagementBadRequestResponse
  | BboStockManagementUnauthorizedResponse
  | BboStockManagementForbiddenResponse
  | BboStockManagementFailureResponseResponse
>;

/**
 * @summary This endpoint is used to store the stock counting into dB and maintaing user activity history
 */
export const usePostStockCount = <
  TError = ErrorType<
    | BboStockManagementBadRequestResponse
    | BboStockManagementUnauthorizedResponse
    | BboStockManagementForbiddenResponse
    | BboStockManagementFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postStockCount>>,
    TError,
    { status: string; data: StockCountRequest },
    TContext
  >;
}) => {
  const mutationOptions = getPostStockCountMutationOptions(options);

  return useMutation(mutationOptions);
};
